export enum GenderEnum {
  ALL = 'ALL',
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  OTHER = 'OTHER',
}
